import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './features/home/Home';
import Sidebar from './layouts/Sidebar';
import MySpaceLayout from './layouts/MySpaceLayout';
import LeaveTrackerLayout from './layouts/LeaveTrackerLayout';
import LeaveSummary from './features/leavetracker/MyData/LeaveSummary';
import MyData from './features/leavetracker/MyData/MyData';
import Team from './features/leavetracker/Team/Team';
import Holiday from './features/leavetracker/Holiday/Holiday';
import React, { useState } from 'react';
import Login from './features/Login';
import ForgotPassword from './features/ForgotPassword';
import ResetPassword from './features/ResetPassword';
import ProtectedRoute from './features/ProtectedRoute';
import CompanyLayout from './layouts/CompanyLayout';
import Members from './features/company/Members';
import LeavePolicy from './features/company/LeavePolicy';
import Holidays from './features/company/Holidays';
import LeaveRequest from './features/leavetracker/MyData/LeaveRequest';
import Overview from './features/myspace/overview/Overview';
import Dashboard from './features/myspace/dashboard/Dashboard';
import Profile from './features/myspace/profile/Profile';
import EmployeeExitForm from './features/leavetracker/Employee/EmployeeExitForm';
import ExitForm from './features/myspace/profile/ExitForm';
import PrivateRoute from './components/common/PrivateRoute';
import Layout from './components/layout/Layout';

function App() {
  const [auth, setAuth] = useState(!!localStorage.getItem('access_token'));

  const handleLogin = () => {
    setAuth(true);
  };

  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <div style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
                <Sidebar />
                <div style={{ flex: 1, padding: '2rem' }}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/myspace/*" element={<MySpaceLayout />}>
                      <Route index element={<Profile />} />
                      <Route path="overview" element={<Overview />} />
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                    </Route>
                    <Route path="/company/*" element={<CompanyLayout />}>
                      <Route index element={<Members />} />
                      <Route path="leave-policy" element={<LeavePolicy />} />
                      <Route path="holidays" element={<Holidays />} />
                    </Route>
                    <Route path="/leavetracker/*" element={<LeaveTrackerLayout />}>
                      <Route path="team" element={<Team />} />
                      <Route path="team/profile/:employeeId" element={<Profile />} />
                      <Route path="mydata" element={<MyData />} />
                      <Route path="holiday" element={<Holiday />} />
                    </Route>
                  </Routes>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
